module.exports = __webpack_public_path__ + "static/media/514.11ce4021.jpg";